import { Col, Row } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import Form from "antd/lib/form/Form";
import { Field, Formik } from "formik";
import { any, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { CompanyService } from "../../../../../services/CompanyService/company.service";
import { MetaService } from "../../../../../services/MetaService/meta.service";
import { AttachmentComponent } from "../../../../../shared/components/AttachmentComponent";
import ButtonComponent from "../../../../../shared/components/ButtonComponent";
import DropdownField from "../../../../../shared/components/DropdownField";
import InputField from "../../../../../shared/components/InputField";
import { UIModal } from "../../../../../shared/components/UIModal";
import {
  assets,
  strategies,
} from "../../../../Auth/CompanyDetails/companyDefinitions";
import { HFundValidation } from "./hFundValidation";
import "./hFundForm.scss";
import { serialize } from "serializr";
import { CompanyModel } from "../../../../../models/HFund/hfund.model";
import { convertJSONToFormData } from "../../../../../shared/utils/dataFormatConverter";

interface HFundFormProps {
  visible: boolean;
  data?: any;
  closeHandler: () => void;
}
interface FormProps {
  id?: string
  companyLogo: any;
  logoUrl: any;
  companyName: string;
  description: string;
  assetUnderManagement: string;
  strategy: string;
  additionalStrategies: string[];
  firstName: string;
  lastName: string;
  companyRoleName: string;
  email: string;
  mobileNumber: string;
  street: string;
  address2: string;
  city: number;
  state: string;
  zipCode: string;
  country: string;
  mailingAddress: boolean;
  billingAddress: boolean;

  mailingStreet: string;
  mailingAddress2: string;
  mailingCity: number;
  mailingState: string;
  mailingZipCode: string;
  mailingCountry: string;
  billingStreet: string;
  billingAddress2: string;
  billingCity: number;
  billingState: string;
  billingZipCode: string;
  billingCountry: string;
  contactPersonName: string;
  contactPersonTitle: string;
  contactPersonPhone: string;
  contactPersonEmail: string;
  password: string;
  confirmPassword: string;
  showPassword: boolean;
}
export const HFundForm = ({ visible, data, closeHandler }: HFundFormProps) => {
  const formRef = React.useRef<any>();
  const [countries, setCountries] = useState<any>();
  const [provinces, setProvinces] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [cities, setCities] = useState<any>();
  const [initialValues, setInitialValues] = React.useState<FormProps>({
    id: "",
    companyLogo: "",
    logoUrl: "",
    companyName: "",
    description: "",
    assetUnderManagement: undefined,
    strategy: undefined,
    additionalStrategies: [""],
    firstName: "",
    lastName: "",
    companyRoleName: "",
    email: "",
    mobileNumber: "",
    street: "",
    address2: "",
    city: undefined,
    state: undefined,
    zipCode: "",
    country: undefined,
    mailingAddress: true,
    billingAddress: true,

    mailingStreet: null,
    mailingAddress2: null,
    mailingCity: undefined,
    mailingState: undefined,
    mailingZipCode: null,
    mailingCountry: undefined,

    billingStreet: null,
    billingAddress2: null,
    billingCity: undefined,
    billingState: undefined,
    billingZipCode: null,
    billingCountry: undefined,

    contactPersonName: "",
    contactPersonTitle: "",
    contactPersonPhone: "",
    contactPersonEmail: "",
    password: "",
    confirmPassword: "",
    showPassword: false
  });
  const handleSubmit = (values: any) => {
    values["addresses"] = [];
    values["status"] = "setup_pending";
    values["addresses"].push({
      addressType: "registered",
      street: values?.street,
      addressLine2: values?.address2,
      city: values?.city,
      zipCode: values?.zipCode,
    });
    // if (values.mailingAddress) {
    //   values["addresses"].push({
    //     addressType: "mailing",
    //     street: values?.street,
    //     addressLine2: values?.address2,
    //     city: values?.city,
    //     zipCode: values?.zipCode,
    //   });
    // } else {
    //   values["addresses"].push({
    //     addressType: "mailing",
    //     street: values?.mailingStreet,
    //     addressLine2: values?.mailingAddress2,
    //     city: values?.mailingCity,
    //     zipCode: values?.mailingZipCode,
    //   });
    // }
    // if (values.billingAddress) {
    //   values["addresses"].push({
    //     addressType: "billing",
    //     street: values?.street,
    //     addressLine2: values?.address2,
    //     city: values?.city,
    //     zipCode: values?.zipCode,
    //   });
    // } else {
    //   values["addresses"].push({
    //     addressType: "billing",
    //     street: values?.billingStreet,
    //     addressLine2: values?.billingAddress2,
    //     city: values?.billingCity,
    //     zipCode: values?.billingZipCode,
    //   });
    // }
    values["admin"] = {
      firstName: values?.firstName,
      lastName: values?.lastName,
      companyRoleName: values?.companyRoleName,
      email: values?.email,
      mobileNumber: values?.mobileNumber,
      password: values?.password,
    };
    setLoading(true)
    if (initialValues.id) {
      // const jsonData = serialize(CompanyModel, data);
      // jsonData["company_logo"] = values["companyLogo"];
      // const payload = convertJSONToFormData({ company: jsonData });
      CompanyService.updateCompany(
        data?.companyId,
        values,
        () => {
          setLoading(false)
          closeHandler()
        },
        () => {
          setLoading(false)
        }
      );
    } else {
      const serializeData = serialize(CompanyModel, values);
      const payload = { company: (serializeData) };
      // const payload = { company: convertJSONToFormData(jsonData) };
      CompanyService.createCompany(
        payload,
        () => {
          setLoading(false)
          closeHandler()
        },
        () => {
          setLoading(false)
        }
      );
    }
  };
  const fetchCountries = () => {
    MetaService.listCountries(
      (countries) => {
        setCountries(countries);
      },
      () => { }
    );
  };
  const fetchProvinces = (countryId: any) => {
    MetaService.listProvinces(
      countryId,
      (provinces) => {
        setProvinces(provinces);
        //console.log(provinces);
      },
      () => { }
    );
  };
  const fetchCities = (countryId: any, provinceId: any) => {
    MetaService.listCities(
      countryId,
      provinceId,
      (cities) => {
        setCities(cities);
      },
      () => { }
    );
  };

  useEffect(() => {
    //console.log(data);
    fetchCountries();
    if (data) {
      let mailingAddress = false;
      let billingAddress = false;
      if (data?.addresses?.length) {
        fetchProvinces(data?.addresses[0]?.country);
        fetchCities(data?.addresses[0]?.country, data?.addresses[0]?.state);
        if (
          data?.addresses[0]?.street == data?.addresses[1]?.street &&
          data?.addresses[0]?.addressLine2 ==
          data?.addresses[1]?.addressLine2 &&
          data?.addresses[0]?.country == data?.addresses[1]?.country &&
          data?.addresses[0]?.state == data?.addresses[1]?.state &&
          data?.addresses[0]?.city == data?.addresses[1]?.city &&
          data?.addresses[0]?.zipCode == data?.addresses[1]?.zipCode
        ) {
          mailingAddress = true;
        }
        if (
          data?.addresses[0]?.street == data?.addresses[2]?.street &&
          data?.addresses[0]?.addressLine2 ==
          data?.addresses[2]?.addressLine2 &&
          data?.addresses[0]?.country == data?.addresses[2]?.country &&
          data?.addresses[0]?.state == data?.addresses[2]?.state &&
          data?.addresses[0]?.city == data?.addresses[2]?.city &&
          data?.addresses[0]?.zipCode == data?.addresses[2]?.zipCode
        ) {
          billingAddress = true;
        }
      }
      setInitialValues({
        id: data?.companyId,
        companyLogo: data?.companyLogo,
        logoUrl: data?.logoUrl,
        companyName: data?.companyName,
        description: data?.description,
        assetUnderManagement: data?.assetUnderManagement,
        strategy: data?.strategy,
        additionalStrategies: data?.additionalStrategies,
        firstName: data?.admin?.firstName,
        lastName: data?.admin?.lastName,
        companyRoleName: data?.admin?.companyRoleName,
        email: data?.admin?.email,
        mobileNumber: data?.admin?.mobileNumber,
        street: data?.addresses[0]?.street,
        address2: data?.addresses[0]?.addressLine2,
        city: data?.addresses[0]?.city,
        state: data?.addresses[0]?.state,
        zipCode: data?.addresses[0]?.zipCode,
        country: data?.addresses[0]?.country,
        mailingAddress: mailingAddress,
        billingAddress: billingAddress,

        mailingStreet: !mailingAddress ? data?.addresses[1]?.street : null,
        mailingAddress2: !mailingAddress
          ? data?.addresses[1]?.addressLine2
          : null,
        mailingCity: !mailingAddress ? data?.addresses[1]?.city : null,
        mailingState: !mailingAddress ? data?.addresses[1]?.state : null,
        mailingZipCode: !mailingAddress ? data?.addresses[1]?.zipCode : null,
        mailingCountry: !mailingAddress ? data?.addresses[1]?.country : null,

        billingStreet: !billingAddress ? data?.addresses[2]?.street : null,
        billingAddress2: !billingAddress
          ? data?.addresses[2]?.addressLine2
          : null,
        billingCity: !billingAddress ? data?.addresses[2]?.city : undefined,
        billingState: !billingAddress ? data?.addresses[2]?.state : undefined,
        billingZipCode: !billingAddress ? data?.addresses[2]?.zipCode : null,
        billingCountry: !billingAddress
          ? data?.addresses[2]?.country
          : undefined,

        contactPersonName: data?.contactPersonName,
        contactPersonTitle: data?.contactPersonTitle,
        contactPersonPhone: data?.contactPersonPhone,
        contactPersonEmail: data?.contactPersonEmail,
        password: data?.password,
        confirmPassword: data?.password,
        showPassword: !data?.adminId
      });
    }
  }, [data]);

  return (
    <UIModal
      visible={visible}
      title={initialValues.id ? "Update HFund" : "Add New HFund"}
      closeModal={() => {
        formRef?.current?.resetForm(initialValues);
        closeHandler();
      }}
      noControl
    // submitProps={{
    //   text: "Create",
    //   type: "button",
    //   clickHandler: () => {},
    // }}
    // cancelProps={{
    //   text: "Cancel",
    //   type: "button",
    //   clickHandler: () => closeHandler(),
    // }}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={() => { }}
        enableReinitialize
        validationSchema={HFundValidation}
        innerRef={formRef}
      >
        {({ setFieldValue, values, errors, isValid, dirty }) => {
          return (
            <Form>
              <div className="hfund-form__container">
                <div className="hfund-form__field">
                  <div className="hfund-form__label">Company Information</div>
                  <Field name="companyLogo" as="file-upload">
                    <AttachmentComponent
                      accept={"image/*"}
                      image={values?.companyLogo || values?.logoUrl}
                      onUpload={(file) => setFieldValue("companyLogo", file)}
                      title="Upload Company Logo"
                    />
                  </Field>
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Management Company Name *"}
                    name="companyName"
                    type="text"
                    value={values?.companyName}
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Description"}
                    name="description"
                    type="textarea"
                    value={values?.description}
                  />
                </div>
                <DropdownField
                  showLabel
                  mode="single"
                  placeholder={"Assets Under Management (USD or equivalent) *"}
                  name="assetUnderManagement"
                  options={assets}
                  showSearch={false}
                  value={values.assetUnderManagement}
                  onChange={(value) =>
                    setFieldValue("assetUnderManagement", value)
                  }
                />

                <div className="hfund-form__field">
                  <DropdownField
                    showLabel
                    mode="single"
                    optionFilterProp="label"
                    placeholder={"Strategy *"}
                    name="strategy"
                    options={strategies}
                    showSearch={false}
                    value={values.strategy}
                    onChange={(value) => setFieldValue("strategy", value)}
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Additional Strategies (Optional)"}
                    name="additionalStrategies"
                    type="text"
                    value={values?.additionalStrategies}
                    onChange={e => {
                      console.log(e)
                      setFieldValue('additionalStrategies', [e.target.value])
                    }}
                  />
                </div>
                {/* <div className="hfund-form__field">
                  <DropdownField
                  showLabel
                    mode="single"
                    optionFilterProp="label"
                    placeholder={"Fund Structure"}
                    name="fundStructure"
                    options={[]}
                    showSearch={false}
                    value={values.fundStructure}
                    onChange={(value) => setFieldValue("fundStructure", value)}
                  />
                </div> */}
                <div className="hfund-form__label">Admin Information</div>

                <Row justify="space-between" className="mtp-4">
                  <Col span={11}>
                    <InputField
                      showLabel
                      placeholder={"First Name"}
                      name="firstName"
                      type="text"
                      value={values?.firstName}
                    />
                  </Col>
                  <Col span={11}>
                    <InputField
                      showLabel
                      placeholder={"Last Name"}
                      name="lastName"
                      type="text"
                      value={values?.lastName}
                    />
                  </Col>
                </Row>

                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Position at Company *"}
                    name="companyRoleName"
                    type="text"
                    value={values?.companyRoleName}
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Email *"}
                    name="email"
                    type="text"
                    value={values?.email}
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Phone Number *"}
                    name="mobileNumber"
                    type="text"
                    value={values?.mobileNumber}
                  />
                </div>
                <div className="hfund-form__label">Registered Address</div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Street *"}
                    name="street"
                    type="text"
                    value={values?.street}
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Address 2"}
                    name="address2"
                    type="text"
                    value={values?.address2}
                  />
                </div>
                <div className="hfund-form__field">
                  <DropdownField
                    showLabel
                    mode="single"
                    optionFilterProp="label"
                    placeholder={"Country *"}
                    name="country"
                    options={countries}
                    showSearch={false}
                    value={values.country}
                    onChange={(value) => {
                      setFieldValue("country", value);
                      setFieldValue("state", undefined);
                      setFieldValue("city", undefined);
                      fetchProvinces(value);
                    }}
                  />
                </div>
                <div className="hfund-form__field">
                  <DropdownField
                    showLabel
                    mode="single"
                    optionFilterProp="label"
                    placeholder={"State/Province *"}
                    name="state"
                    options={provinces}
                    showSearch={false}
                    value={values.state}
                    onChange={(value) => {
                      setFieldValue("state", value);
                      setFieldValue("city", undefined);
                      fetchCities(values?.country, value);
                    }}
                  />
                  <div className="hfund-form__field">
                    <DropdownField
                      showLabel
                      mode="single"
                      optionFilterProp="label"
                      placeholder={"City *"}
                      name="city"
                      options={cities}
                      showSearch={false}
                      value={values.city}
                      onChange={(value) => {
                        setFieldValue("city", value);
                      }}
                    />
                  </div>
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Zip Code/Postal Code *"}
                    name="zipCode"
                    type="text"
                    value={values?.zipCode}
                  />
                </div>

                {/* <div className="hfund-form__label">Mailing Address</div>
                <div className="hfund-form__field">
                  <Checkbox
                    className="mtp-3"
                    checked={values?.mailingAddress}
                    onChange={(e) => {
                      //console.log();
                      setFieldValue("mailingAddress", e.target.checked);
                    }}
                  >
                    Same as registered address
                  </Checkbox>
                </div>
                {!values?.mailingAddress && (
                  <>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Street *"}
                        name="mailingStreet"
                        value={values.mailingStreet}
                        type="text"
                      />
                    </div>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Address 2"}
                        name="mailingAddress2"
                        value={values.mailingAddress2}
                        type="text"
                      />
                    </div>
                    <div className="hfund-form__field">
                      <DropdownField
                        showLabel
                        mode="single"
                        optionFilterProp="label"
                        placeholder={"Country"}
                        name="mailingCountry"
                        options={countries}
                        showSearch={false}
                        value={values.mailingCountry}
                        onChange={(value) => {
                          setFieldValue("mailingCountry", value);
                          fetchProvinces(value);
                        }}
                      />
                    </div>
                    <div className="hfund-form__field">
                      <DropdownField
                        showLabel
                        mode="single"
                        optionFilterProp="label"
                        placeholder={"State/Province *"}
                        name="mailingState"
                        options={provinces}
                        showSearch={false}
                        value={values.mailingState}
                        onChange={(value) => {
                          setFieldValue("mailingState", value);
                          fetchCities(values?.country, value);
                        }}
                      />
                      <div className="hfund-form__field">
                        <DropdownField
                          showLabel
                          mode="single"
                          optionFilterProp="label"
                          placeholder={"City *"}
                          name="mailingCity"
                          options={cities}
                          showSearch={false}
                          value={values.mailingCity}
                          onChange={(value) => {
                            setFieldValue("mailingCity", value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Zip Code/Postal Code *"}
                        name="mailingZipCode"
                        value={values.mailingZipCode}
                        type="text"
                      />
                    </div>
                  </>
                )}
                <div className="hfund-form__label">Billing Address</div>
                <div className="hfund-form__field">
                  <Checkbox
                    checked={values?.billingAddress}
                    className="mtp-3"
                    onChange={(e) =>
                      setFieldValue("billingAddress", e.target.checked)
                    }
                  >
                    Same as registered address
                  </Checkbox>
                </div>
                {!values?.billingAddress && (
                  <>
                    <div className="hfund-form__label">Billing Address</div>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Street *"}
                        name="billingStreet"
                        value={values.billingStreet}
                        type="text"
                      />
                    </div>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Address 2"}
                        name="billingAddress2"
                        value={values.billingAddress2}
                        type="text"
                      />
                    </div>
                    <div className="hfund-form__field">
                      <DropdownField
                        showLabel
                        mode="single"
                        optionFilterProp="label"
                        placeholder={"Country"}
                        name="billingCountry"
                        value={values.billingCountry}
                        options={countries}
                        showSearch={false}
                        onChange={(value) => {
                          setFieldValue("billingCountry", value);
                          fetchProvinces(value);
                        }}
                      />
                    </div>
                    <div className="hfund-form__field">
                      <DropdownField
                        showLabel
                        mode="single"
                        optionFilterProp="label"
                        placeholder={"State/Province *"}
                        name="billingState"
                        value={values.billingState}
                        options={provinces}
                        showSearch={false}
                        onChange={(value) => {
                          setFieldValue("billingState", value);
                          fetchCities(values?.country, value);
                        }}
                      />
                      <div className="hfund-form__field">
                        <DropdownField
                          showLabel
                          mode="single"
                          optionFilterProp="label"
                          placeholder={"City *"}
                          name="billingCity"
                          value={values.billingCity}
                          options={cities}
                          showSearch={false}
                          onChange={(value) => {
                            setFieldValue("billingCity", value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Zip Code/Postal Code *"}
                        name="billingZipCode"
                        value={values.billingZipCode}
                        type="text"
                      />
                    </div>
                  </>
                )} */}
                <div className="hfund-form__label">
                  Contact Person Information
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Contact Person Name *"}
                    name="contactPersonName"
                    value={values.contactPersonName}
                    type="text"
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Contact Person Title *"}
                    name="contactPersonTitle"
                    value={values.contactPersonTitle}
                    type="text"
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Contact Person Telephone *"}
                    name="contactPersonPhone"
                    value={values.contactPersonPhone}
                    type="text"
                  />
                </div>
                <div className="hfund-form__field">
                  <InputField
                    showLabel
                    placeholder={"Contact Person Email *"}
                    name="contactPersonEmail"
                    value={values.contactPersonEmail}
                    type="text"
                  />
                </div>
                {!data?.admin && (
                  <>
                    <div className="hfund-form__label">Create Password</div>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Password *"}
                        name="password"
                        value={values.password}
                        type="password"
                      />
                    </div>
                    <div className="hfund-form__field">
                      <InputField
                        showLabel
                        placeholder={"Confirm Password *"}
                        name="confirmPassword"
                        value={values.confirmPassword}
                        type="password"
                      />
                    </div>
                  </>
                )}
                <div className="ui-modal__controllers">
                  <ButtonComponent onClick={() => closeHandler()} type="ghost">
                    Cancel
                  </ButtonComponent>
                  <ButtonComponent
                    htmlType={"button"}
                    onClick={() => handleSubmit(values)}
                    loading={loading}
                    disabled={!isValid || !dirty}
                    type="primary"
                  >
                    {initialValues?.id ? "Update" : "Create"}
                  </ButtonComponent>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </UIModal>
  );
};
